import React, { Component } from 'react';
import config from '../../../../config';
import { Container } from 'semantic-ui-react';
import { PtInput, PtSelect } from '../../../../grit-utilities';
import ScrollArea from 'react-scrollbar';
import AgencyInfo from '../../../../AgencyInfo';
import $ from 'jquery';

export default class Future extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...this.props.futureModel.pavementcondition,
            selectedYear: new Date().getFullYear(),
            PQI: 'N.A.',
            Age: 'N.A.',
            Aadt: 'N.A.',
            Esals: 'N.A.',
            CumEsals: 'N.A.',
            PQItype: 'N.A',
            pqiArray: []
        };
    }
    getYearOptions = () => {
        const yearOptions = [];
        for (let i = 0; i < 35; i++) {
            yearOptions.push({ key: new Date().getFullYear() + i, value: new Date().getFullYear() + i, label: new Date().getFullYear() + i });
        }
        return yearOptions;
    }

    //adding background layer functionality to match year picker in main menu file
    selectBackgroundLayerPQI = (layer, e) => {
        const county = AgencyInfo.getSelectedAgencyId();
        let year
        if (layer === 'getPQI') {
            if (e !== year)
                year = e
            else
                year = new Date().getFullYear();

            $.ajax({
                type: 'GET',
                url: `${config.server}\\getbackgroundPQI\\${county}\\${year}`,
                contentType: 'application/json',
                success: (data) => {

                    this.props.clickFunctions.toggleSpecialLayer(false);
                    this.setState({ backgroundLegend: data[1], legendName: data[2][0].LegendName });
                    this.props.clickFunctions.onLoadBackgroundLayer(data[0]);


                },
            });
        }
    }
    render() {
        const yearOptions = this.getYearOptions();
        return (
            <Container>
                <ScrollArea
                    speed={1}
                    className={!window.mobileAndTabletcheck() ? "area_desktop" : "area_mobile"}
                    contentClassName="content"
                    smoothScrolling={true}>
                    <PtSelect name="selectedYear" defaultVal={this.state.selectedYear} label="Select Year" options={yearOptions} onChange={this.onChangeDropdown} />

                    <PtInput disabled placeholder="Not Available" name="PQI" value={this.state.PQI ? this.state.PQI : ''} label="PQI - Pavement Quality Index" />

                    <PtInput disabled placeholder="Not Available" name="Age" value={this.state.Age ? this.state.Age : ''} label="Age" />

                    <PtInput disabled placeholder="Not Available" name="Aadt" value={this.state.Aadt ? Math.round(this.state.Aadt) : ''} label="AADT" />

                    <PtInput disabled placeholder="Not Available" name="Esals" value={this.state.Esals ? Math.round(this.state.Esals) : ''} label="ESALs"  />

                    <PtInput disabled placeholder="Not Available" name="CumEsals" value={this.state.CumEsals ? Math.round(this.state.CumEsals) : ''} label="Cumulative ESALs" />
                </ScrollArea>
            </Container>
        );
    }
    
    onChangeDropdown = (e) => {
        const { target } = e;
        const { name, value } = target;
        // eslint-disable-next-line
        this.setState({ [name]: parseInt(value) }, () => {
            // this.fetchProjectionData(value);
            this.selectBackgroundLayerPQI('getPQI', value);
        });
    }


    /* This function actually gets the PQI value for the current year and future years based on routeId and year from FutureTabView hard table
    Author: Souradip Roy
    Date: 09/25/2019
    */
    getfirstPQI = () => {
        let pqi
        let pqiType
        fetch(`${config.server}/getfirstpqi/` + this.props.futureModel.route.id + `/` + this.state.selectedYear)
            .then(response => response.json())
            .then(data => {
                console.log(data.length)
                if (data.length === 0)
                    this.setState({ PQI: 'N.A.' })
                else if (data.length !== 0) {

                    pqi = data[0]['PSR']
                    pqiType = data[0]['PSRType']
                    if (pqi === null)
                        this.setState({
                            PQI: null,
                            Age: data[0]['Age'],
                            Esals: data[0]['Esals'],
                            Aadt: data[0]['AADT'],
                            CumEsals: data[0]['CumEsal']
                        })
                    else if (pqi != null) {
                        this.setState({
                            PQI: (pqi).toFixed(2) + '  [' + pqiType + ']',
                            Age: data[0]['Age'],
                            Esals: data[0]['Esals'],
                            Aadt: data[0]['AADT'],
                            CumEsals: data[0]['CumEsal']
                        })
                    }
                }
            })
    }

    onChangeDropdown = (e) => {
        const { target } = e;
        const { name, value } = target;
        // eslint-disable-next-line
        this.setState({ [name]: parseInt(value) }, () => {
            this.getfirstPQI()
        });
    }
    componentDidMount() {
        this.getfirstPQI();
    }

}


// WEBPACK FOOTER //
// ./src/layers/tabs/cons-segment/forecasting/future.js